import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('hrms_token');
      const storedUser = localStorage.getItem('hrms_user');
      
      if (token && storedUser) {
        try {
          const userData = await authService.getMe();
          setUser(userData);
          setIsAuthenticated(true);
        } catch (error) {
          localStorage.removeItem('hrms_token');
          localStorage.removeItem('hrms_user');
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (username, password) => {
    const response = await authService.login(username, password);
    localStorage.setItem('hrms_token', response.access_token);
    localStorage.setItem('hrms_user', JSON.stringify(response.user));
    setUser(response.user);
    setIsAuthenticated(true);
    return response.user;
  };

  const register = async (userData) => {
    const response = await authService.register(userData);
    localStorage.setItem('hrms_token', response.access_token);
    localStorage.setItem('hrms_user', JSON.stringify(response.user));
    setUser(response.user);
    setIsAuthenticated(true);
    return response.user;
  };

  const loginWithOtp = async (response) => {
    // response is the TokenResponse from /auth/verify-otp
    localStorage.setItem('hrms_token', response.access_token);
    localStorage.setItem('hrms_user', JSON.stringify(response.user));
    setUser(response.user);
    setIsAuthenticated(true);
    return response.user;
  };

  const logout = () => {
    localStorage.removeItem('hrms_token');
    localStorage.removeItem('hrms_user');
    setUser(null);
    setIsAuthenticated(false);
  };

  const hasRole = (roles) => {
    if (!user) return false;
    if (typeof roles === 'string') {
      return user.role === roles;
    }
    return roles.includes(user.role);
  };

  const isAdmin = () => hasRole(['super_admin', 'hr', 'admin']);
  const isManager = () => hasRole(['super_admin', 'hr', 'admin', 'manager']);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated,
        login,
        register,
        loginWithOtp,
        logout,
        hasRole,
        isAdmin,
        isManager,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
